var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.checkChatOpen),expression:"checkChatOpen"}],ref:"containerChat",staticClass:"messages-widget"},[_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('Messages',{attrs:{"isWidget":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }